<template>
  <b-form-group
    :id="'group' + id"
    :class="`text-input-group ${requireError ? 'require-field' : ''}`"
    :label-for="id"
    :label="`${$translate(placeholder)} ${required ? '*' : ''}`"
    :state="!isError"
    :invalid-feedback="errorMessage"
  >
    <div class="wrapper">
      <BFormTextarea
        :id="id"
        :ref="id"
        v-model="text"
        :type="'text'"
        size="sm"
        trim
        :placeholder="$translate(placeholder)"
        :required="required"
        :rows="rows"
        :disabled="disabled || viewMode"
        :class="`input ${viewMode ? 'viewMode' : ''}`"
        @input="updateValue"
        @focus="focused = true"
        @blur="focused = false"
      />
    </div>
    <b-form-text>
      {{ bottomText }}
    </b-form-text>
  </b-form-group>
</template>

<script>
import { BFormTextarea } from 'bootstrap-vue';

export default {
  name: 'TextArea',
  components: { BFormTextarea },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    bottomText: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    rows: {
      type: String,
      default: '5',
    },
    value: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    tileSize: {
      type: Number,
      default: 14,
    },
    updateError: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      text: null,
      focused: false,
      id: '',
    };
  },
  computed: {
    requireError: function () {
      return this.required && !this.text;
    },
    isError: function () {
      const error = this.error || this.requireError;
      this.updateError(error);
      return error;
    },
  },
  watch: {
    value(newVal) {
      this.text = newVal;
    },
  },
  mounted() {
    this.id =
      Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, '') + new Date().getTime();
    this.text = this.value;
  },
  methods: {
    setFocus() {
      this.$refs[this.id].$el.focus();
    },
    updateValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .d-block {
  font-size: 16px;
  line-height: 20px;
}
::v-deep .form-control {
  padding: 12px;
  font-size: 16px;
  line-height: 20px;
  height: fit-content;
  border: 1px solid #C5D0DE;
  border-radius: 4px;
}
::v-deep .form-control.is-invalid {
  border-color: #ED3232;
  background: rgba(237, 50, 50, 0.05);
  color: #ED3232;
}
::v-deep .form-control:focus {
  background-color: rgba(34, 96, 255, 0.02);
  border: 1px solid #2260FF;
  box-shadow: 4px 0px 16px rgba(34, 96, 255, 0.04);
}
.input {
  resize: none;
}
.wrapper {
  display: flex;
}
.text-input-group.require-field,
.text-input-group.is-invalid {
  color: #ED3232;
}
.text-input-group {
  position: relative;
}
.viewMode {
  background-color: #fff !important;
}
</style>
